import { render, staticRenderFns } from "./AGTable.vue?vue&type=template&id=be314aa0&"
import script from "./AGTable.vue?vue&type=script&lang=ts&"
export * from "./AGTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports